export const isNotEmptyObject = (obj?: Object) => {
  if (!obj) return false;
  return Object.keys(obj).length > 0;
};

export const objectHasKey = (obj: Object, key: string) => {
  if (!isNotEmptyObject(obj)) return false;
  return obj.hasOwnProperty(key);
};

export const getOptionsFromObject = (obj: Object) => {
  return Object.entries(obj).map(([id, label]) => ({
    id,
    label,
  }));
};
